"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ThemeProvider = require("../../theme/ThemeProvider");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var disabled = function disabled(theme) {
  return {
    cursor: 'default',
    color: theme['$inactive-link-color'],
    textDecoration: 'none'
  };
};

var makeStyles = (0, _ThemeProvider.createUseStyles)({
  Link: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: function color(_ref) {
      var theme = _ref.theme;
      return theme['$link-color'];
    },
    fontWeight: 500,
    fontFamily: function fontFamily(_ref2) {
      var theme = _ref2.theme;
      return theme['$font-default'];
    },
    fontSize: 12,
    '&:hover': {
      textDecoration: 'underline',
      color: function color(_ref3) {
        var theme = _ref3.theme;
        return theme['$link-color'];
      }
    },
    '&:active': {
      textDecoration: 'underline',
      color: function color(_ref4) {
        var theme = _ref4.theme;
        return theme['$link-color'];
      }
    },
    '&:inactive': function inactive(_ref5) {
      var theme = _ref5.theme;
      return disabled(theme);
    },
    '&.cap-width': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: function maxWidth(_ref6) {
        var props = _ref6.props;
        return (props === null || props === void 0 ? void 0 : props.maxWidth) || 300;
      },
      display: 'inline-block',
      verticalAlign: 'bottom'
    }
  },
  Disabled: function Disabled(_ref7) {
    var theme = _ref7.theme;
    return _objectSpread(_objectSpread({}, disabled(theme)), {}, {
      '&:hover': function hover(_ref8) {
        var theme = _ref8.theme;
        return disabled(theme);
      },
      '&:active': function active(_ref9) {
        var theme = _ref9.theme;
        return disabled(theme);
      }
    });
  },
  Dotted: {
    textDecoration: 'underline',
    textDecorationStyle: 'dotted'
  }
});
var _default = makeStyles;
exports["default"] = _default;
//# sourceMappingURL=style.js.map